import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import frame1 from '../../assets/images/destination.png'
import frame2 from '../../assets/images/love.png'
import frame3 from '../../assets/images/traveler.png'
// import tourist from '../../assets/images/touriest1.png'
import { Swiper, SwiperSlide } from 'swiper/react';

import goa from '../../assets/images/goa.jpg'
import like from '../../assets/images/Frame 2056.png'
import bottomImg from '../../assets/images/shape6.png'
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// import './styles.css';

// import required modules
import { Pagination } from 'swiper/modules';
import { packageData } from './packageData'
import { Link } from 'react-router-dom'
import bannerend from '../../assets/images/shape-pat.png'
import LetterPad from '../LetterPad'
import Model from '../layouts/Model';

const Home = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (<>
        <div className='home-banner'>
            {/* <img src={bannerend} alt='' className='bottomImg' /> */}
            <div className='banner'>

                {/* <h1>
            Your Journey Begins
            </h1>
            <p>A journey of a 1000 miles starts with a single step. <br/> Import the full demo content with 1 click and create a head-turning website for your travel agency.
            </p> */}
            </div>
        </div>


        {/* <!-- =====================================  How It Works   ===================================== --> */}

        <div className="It-Works">
            {/* <div className="littleboy">
    <img src={tourist} alt='tourist' width={400} height={468}/>
</div> */}
            <h2>
                How It Works
            </h2>
            <p>Simplifying the booking process for your next adventure</p>
            <div className="container">
                <Row gutter={[30, 30]}>
                    <Col xs={24} sm={12} md={12} lg={8}>
                        <div className="card">
                        <span> <img src={frame1} alt="" /></span>
                            <h6>
                                Planned Trips
                            </h6>
                            <p>For over a decade, Travelance Holidays has been curating exceptional international travel experiences.</p>
                            {/* <div className="boxButton">
                                <p>Join Us</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M3 9.05713C3 8.64292 3.33579 8.30713 3.75 8.30713H14.25C14.6642 8.30713 15 8.64292 15 9.05713C15 9.47134 14.6642 9.80713 14.25 9.80713H3.75C3.33579 9.80713 3 9.47134 3 9.05713Z" fill="#192335" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.46967 3.2768C8.76256 2.98391 9.23744 2.98391 9.53033 3.2768L14.7803 8.5268C15.0732 8.81969 15.0732 9.29457 14.7803 9.58746L9.53033 14.8375C9.23744 15.1304 8.76256 15.1304 8.46967 14.8375C8.17678 14.5446 8.17678 14.0697 8.46967 13.7768L13.1893 9.05713L8.46967 4.33746C8.17678 4.04457 8.17678 3.56969 8.46967 3.2768Z" fill="#192335" />
                                </svg>
                            </div> */}
                        </div>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={8}>
                        <div className="card">
                            <span>                    <img src={frame2} alt="" />
                            </span>
                            <h6>
                                Handcrafted

                                Experiences
                            </h6>
                            <p>Every itinerary is thoughtfully designed to match the unique preferences of our customers.
                            </p>
                            {/* <div className="boxButton" style={{ backgroundColor: "#176a78", color: "#176a78" }}>
                                <p style={{ color: "#fff" }}> Go To Package</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M3.5 9.05713C3.5 8.64292 3.83579 8.30713 4.25 8.30713H14.75C15.1642 8.30713 15.5 8.64292 15.5 9.05713C15.5 9.47134 15.1642 9.80713 14.75 9.80713H4.25C3.83579 9.80713 3.5 9.47134 3.5 9.05713Z" fill="white" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.96967 3.2768C9.26256 2.98391 9.73744 2.98391 10.0303 3.2768L15.2803 8.5268C15.5732 8.81969 15.5732 9.29457 15.2803 9.58746L10.0303 14.8375C9.73744 15.1304 9.26256 15.1304 8.96967 14.8375C8.67678 14.5446 8.67678 14.0697 8.96967 13.7768L13.6893 9.05713L8.96967 4.33746C8.67678 4.04457 8.67678 3.56969 8.96967 3.2768Z" fill="white" />
                                </svg>
                            </div> */}
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8}>
                        <div className="card">
                        <span> <img src={frame3} alt="" /></span>
                            <h6>
                                Delighted Travelers
                            </h6>
                            <p>Unmatched customer satisfaction has helped us build lasting relationships and loyal travel buddies.
                            </p>
                            {/* <div className="boxButton">
                                <p>Book Now</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M3 9.05713C3 8.64292 3.33579 8.30713 3.75 8.30713H14.25C14.6642 8.30713 15 8.64292 15 9.05713C15 9.47134 14.6642 9.80713 14.25 9.80713H3.75C3.33579 9.80713 3 9.47134 3 9.05713Z" fill="#192335" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.46967 3.2768C8.76256 2.98391 9.23744 2.98391 9.53033 3.2768L14.7803 8.5268C15.0732 8.81969 15.0732 9.29457 14.7803 9.58746L9.53033 14.8375C9.23744 15.1304 8.76256 15.1304 8.46967 14.8375C8.17678 14.5446 8.17678 14.0697 8.46967 13.7768L13.1893 9.05713L8.46967 4.33746C8.17678 4.04457 8.17678 3.56969 8.46967 3.2768Z" fill="#192335" />
                                </svg>
                            </div> */}
                        </div>
                    </Col>
                </Row>
            </div>
        </div>

        {/* <!-- =====================================  Quotes   ===================================== --> */}


        <div className='quotes'>
            <img src={bottomImg} alt='' className='bottomImg' style={{ rotate: "0deg" }} />
            <div className='quotes-content'>
                <h4>Love Where You are Going</h4>
                <h1><span> Travel where your heart leads </span> and let the journey <br /> inspire you!</h1>
                <p>Once bitten by the travel bug, the only antidote is endless adventures.</p>
            </div>
            <div className='white-overlay'></div>
        </div>



        {/* <!-- =====================================  Features   ===================================== --> */}
        <div className="features">
            <h2>Our <span>Packeges</span></h2>
            <p>Effortlessly plan your holidays with us.</p>
            <Swiper
                breakpoints={{
                    1122: {
                        slidesPerView: 3,
                    },
                    792: {
                        slidesPerView: 2,
                    },
                    320: {
                        slidesPerView: 1,
                    }
                }}
                slidesPerView={3}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination]}
                className="mySwiper"
            >
                {packageData.map((item) => {
                    return (
                        <SwiperSlide>
                            <div className="card">
                                <div style={{ width: "100%", height: 300 }}>
                                    <img src={item.img} alt="" height={300} />
                                    <div className="button1">
                                        Popular
                                    </div>
                                    {/* <div className="button2">
                                        <h3>$450</h3>
                                        <h3 style={{ fontSize: 14, fontWeight: 400 }}>/hr</h3>
                                    </div> */}
                                </div>
                                <div class="card__info" style={{ width: "100%" }}>
                                    <div className="card-hero">
                                        <div className="card-top">
                                            <div className="cardReview">
                                                <div className="showReview">
                                                    4.5
                                                </div>
                                                <p>120 Reviews</p>
                                            </div>
                                            <div>
                                                <img src={like} alt="" />
                                            </div>
                                        </div>
                                        <div className="card-medium">
                                            <h6>{item.place}</h6>
                                            <p>Travelance</p>
                                            <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M8 1.33333C6.58551 1.33333 5.22895 1.89524 4.22876 2.89543C3.22856 3.89562 2.66666 5.25218 2.66666 6.66667C2.66666 8.73204 4.01049 10.7362 5.48396 12.2915C6.20707 13.0548 6.93244 13.6796 7.47778 14.1139C7.68074 14.2755 7.85801 14.4101 7.99999 14.5151C8.14198 14.4101 8.31925 14.2755 8.52221 14.1139C9.06755 13.6796 9.79292 13.0548 10.516 12.2915C11.9895 10.7362 13.3333 8.73204 13.3333 6.66667C13.3333 5.25218 12.7714 3.89562 11.7712 2.89543C10.771 1.89524 9.41448 1.33333 8 1.33333ZM8 15.3333C7.6302 15.888 7.63003 15.8879 7.62983 15.8878L7.62793 15.8865L7.62349 15.8835L7.60821 15.8732C7.59523 15.8644 7.57671 15.8517 7.55303 15.8353C7.50568 15.8025 7.43764 15.7547 7.35186 15.6928C7.18036 15.5689 6.93757 15.3881 6.64721 15.1569C6.06755 14.6954 5.29292 14.0286 4.51603 13.2085C2.9895 11.5972 1.33333 9.26796 1.33333 6.66667C1.33333 4.89856 2.03571 3.20286 3.28595 1.95262C4.53619 0.702379 6.23188 0 8 0C9.7681 0 11.4638 0.702379 12.714 1.95262C13.9643 3.20286 14.6667 4.89856 14.6667 6.66667C14.6667 9.26796 13.0105 11.5972 11.484 13.2085C10.7071 14.0286 9.93244 14.6954 9.35278 15.1569C9.06242 15.3881 8.81963 15.5689 8.64813 15.6928C8.56235 15.7547 8.49431 15.8025 8.44696 15.8353C8.42328 15.8517 8.40476 15.8644 8.39178 15.8732L8.3765 15.8835L8.37206 15.8865L8.37065 15.8875C8.37046 15.8876 8.36979 15.888 8 15.3333ZM8 15.3333L8.36979 15.888C8.14586 16.0373 7.85377 16.0371 7.62983 15.8878L8 15.3333Z" fill="#A0A0A0" />
                                                <path fillRule="evenodd" clipRule="evenodd" d="M7.99999 5.33333C7.26362 5.33333 6.66666 5.93029 6.66666 6.66667C6.66666 7.40305 7.26362 8 7.99999 8C8.73637 8 9.33333 7.40305 9.33333 6.66667C9.33333 5.93029 8.73637 5.33333 7.99999 5.33333ZM5.33333 6.66667C5.33333 5.19391 6.52724 4 7.99999 4C9.47275 4 10.6667 5.19391 10.6667 6.66667C10.6667 8.13943 9.47275 9.33333 7.99999 9.33333C6.52724 9.33333 5.33333 8.13943 5.33333 6.66667Z" fill="#A0A0A0" />
                                            </svg> <h5 style={{ color: "192335" }}>{item.country}</h5></div>
                                            <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M3.33333 3.33333C2.96514 3.33333 2.66666 3.63181 2.66666 4V13.3333C2.66666 13.7015 2.96514 14 3.33333 14H12.6667C13.0349 14 13.3333 13.7015 13.3333 13.3333V4C13.3333 3.63181 13.0349 3.33333 12.6667 3.33333H3.33333ZM1.33333 4C1.33333 2.89543 2.22876 2 3.33333 2H12.6667C13.7712 2 14.6667 2.89543 14.6667 4V13.3333C14.6667 14.4379 13.7712 15.3333 12.6667 15.3333H3.33333C2.22876 15.3333 1.33333 14.4379 1.33333 13.3333V4Z" fill="#A0A0A0" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M10.6667 0.666504C11.0349 0.666504 11.3333 0.964981 11.3333 1.33317V3.99984C11.3333 4.36803 11.0349 4.6665 10.6667 4.6665C10.2985 4.6665 10 4.36803 10 3.99984V1.33317C10 0.964981 10.2985 0.666504 10.6667 0.666504Z" fill="#A0A0A0" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M5.33334 0.666504C5.70153 0.666504 6.00001 0.964981 6.00001 1.33317V3.99984C6.00001 4.36803 5.70153 4.6665 5.33334 4.6665C4.96515 4.6665 4.66667 4.36803 4.66667 3.99984V1.33317C4.66667 0.964981 4.96515 0.666504 5.33334 0.666504Z" fill="#A0A0A0" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M1.33333 6.66667C1.33333 6.29848 1.63181 6 1.99999 6H14C14.3682 6 14.6667 6.29848 14.6667 6.66667C14.6667 7.03486 14.3682 7.33333 14 7.33333H1.99999C1.63181 7.33333 1.33333 7.03486 1.33333 6.66667Z" fill="#A0A0A0" />
                                                </svg>
                                                <h5>Trip Duriation : </h5>
                                                <h5 style={{ color: "#097E52", width: "auto" }}>{item.tripDur}</h5>
                                            </div>
                                        </div>
                                        <div className="card-bottom">
                                            <div className="bottomProfile">
                                            </div>
                                            <div className="bookbutton" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M3.75 4.25C3.33579 4.25 3 4.58579 3 5V15.5C3 15.9142 3.33579 16.25 3.75 16.25H14.25C14.6642 16.25 15 15.9142 15 15.5V5C15 4.58579 14.6642 4.25 14.25 4.25H3.75ZM1.5 5C1.5 3.75736 2.50736 2.75 3.75 2.75H14.25C15.4926 2.75 16.5 3.75736 16.5 5V15.5C16.5 16.7426 15.4926 17.75 14.25 17.75H3.75C2.50736 17.75 1.5 16.7426 1.5 15.5V5Z" fill="#192335" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V5C12.75 5.41421 12.4142 5.75 12 5.75C11.5858 5.75 11.25 5.41421 11.25 5V2C11.25 1.58579 11.5858 1.25 12 1.25Z" fill="#192335" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M6 1.25C6.41421 1.25 6.75 1.58579 6.75 2V5C6.75 5.41421 6.41421 5.75 6 5.75C5.58579 5.75 5.25 5.41421 5.25 5V2C5.25 1.58579 5.58579 1.25 6 1.25Z" fill="#192335" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M1.5 8C1.5 7.58579 1.83579 7.25 2.25 7.25H15.75C16.1642 7.25 16.5 7.58579 16.5 8C16.5 8.41421 16.1642 8.75 15.75 8.75H2.25C1.83579 8.75 1.5 8.41421 1.5 8Z" fill="#192335" />
                                                </svg>
                                                <p style={{ margin: 0 }} onClick={showModal}>Book Now</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    )
                })}


            </Swiper>
            <Link to={"/packages/domestic"} style={{ textDecoration: "none" }}>           <div className="boxButton" style={{ backgroundColor: "#176a78", color: "#176a78", padding: "20px 10px", borderRadius: 10, display: "flex", justifyContent: "center", alignItems: "center", gap: 10, marginTop: 20, cursor: "pointer" }}>
                <p style={{ color: "#fff" }}> See More </p>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M3.5 9.05713C3.5 8.64292 3.83579 8.30713 4.25 8.30713H14.75C15.1642 8.30713 15.5 8.64292 15.5 9.05713C15.5 9.47134 15.1642 9.80713 14.75 9.80713H4.25C3.83579 9.80713 3.5 9.47134 3.5 9.05713Z" fill="white" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.96967 3.2768C9.26256 2.98391 9.73744 2.98391 10.0303 3.2768L15.2803 8.5268C15.5732 8.81969 15.5732 9.29457 15.2803 9.58746L10.0303 14.8375C9.73744 15.1304 9.26256 15.1304 8.96967 14.8375C8.67678 14.5446 8.67678 14.0697 8.96967 13.7768L13.6893 9.05713L8.96967 4.33746C8.67678 4.04457 8.67678 3.56969 8.96967 3.2768Z" fill="white" />
                </svg>
            </div>
            </Link>
        </div>


        {/* <!-- =====================================  Letter pad  ===================================== --> */}
        <Model isModalOpen={isModalOpen} handleOk={handleOk} handleCancel={handleCancel} />
        <LetterPad />



    </>





    )
}

export default Home